import { Icon } from "@iconify/react/dist/iconify.js";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSearch,
  setEscuelaFilter,
  setPlantelFilter,
} from "../../store/reducers/users/users.reducer";
import {
  getEscuelasThunk,
  getPlantelesThunk,
} from "../../store/reducers/users/users.thunks";
import { resetForm } from "../../store/reducers/users/usersForm.slice";
import Modal from "../UI/Modal";
import UserFormWizard from "./UserFormWizard";
import SearchInput from "../UI/SearchInput";

const UsersHeader = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const searchValue = useSelector((state) => state.users.search);
  const escuelaFilter = useSelector((state) => state.users.escuelaFilter);
  const plantelFilter = useSelector((state) => state.users.plantelFilter);
  const escuelas = useSelector((state) => state.users.escuelas);
  const planteles = useSelector((state) => state.users.planteles);
  const institucionesLoading = useSelector(
    (state) => state.users.institucionesLoading,
  );

  // Carga escuelas al montar
  useEffect(() => {
    dispatch(getEscuelasThunk());
  }, [dispatch]);

  // Cuando cambia la escuela, carga sus planteles
  const handleEscuelaChange = (e) => {
    const value = e.target.value;
    const numericValue = value ? Number(value) : null;

    dispatch(setEscuelaFilter(numericValue));

    if (numericValue) {
      dispatch(getPlantelesThunk(numericValue));
    }
  };

  const handlePlantelChange = (e) => {
    const value = e.target.value;
    dispatch(setPlantelFilter(value ? Number(value) : null));
  };

  const handleSearchChange = (value) => {
    dispatch(setSearch(value));
  };

  const handleClose = () => {
    setOpen(false);
    setTimeout(() => dispatch(resetForm()), 300);
  };

  return (
    <div className="mb-3">
      {/* Fila 1: título + botón */}
      <div className="row g-2 align-items-center mb-2">
        <div className="col-12 col-md-auto">
          <h5 className="mb-0 fw-semibold text-center text-md-start">
            Gestión de usuarios
          </h5>
        </div>
        <div className="col-12 col-md d-flex justify-content-md-end">
          <button
            onClick={() => setOpen(true)}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-2 radius-8"
            style={{ height: "44px", minWidth: "140px" }}
          >
            <Icon icon="mdi:plus" width="20" />
            <span className="d-none d-sm-inline fw-medium">
              Agregar usuario
            </span>
            <span className="d-inline d-sm-none fw-medium">Nuevo</span>
          </button>
        </div>
      </div>

      {/* Fila 2: buscador + filtros */}
      <div className="row g-2 align-items-center">
        {/* Buscador */}
        <div className="col-12 col-sm-6 col-lg-4">
          <SearchInput
            value={searchValue}
            onChange={handleSearchChange}
            placeholder="Buscar por nombre, email, CURP..."
            minChars={3}
          />
        </div>

        {/* Select escuela */}
        <div className="col-12 col-sm-6 col-lg-3">
          <select
            className="form-select"
            style={{ height: "44px" }}
            value={escuelaFilter || ""}
            onChange={handleEscuelaChange}
            disabled={institucionesLoading}
          >
            <option value="">Todas las escuelas</option>
            {escuelas.map((esc) => (
              <option key={esc.id} value={esc.id}>
                {esc.label}
              </option>
            ))}
          </select>
        </div>

        {/* Select plantel */}
        <div className="col-12 col-sm-6 col-lg-3">
          <select
            className="form-select"
            style={{ height: "44px" }}
            value={plantelFilter || ""}
            onChange={handlePlantelChange}
            disabled={!escuelaFilter || institucionesLoading}
          >
            <option value="">Todos los planteles</option>
            {planteles.map((p) => (
              <option key={p.id} value={p.id}>
                {p.label}
              </option>
            ))}
          </select>
        </div>

        {/* Botón limpiar filtros (solo si hay alguno activo) */}
        {(escuelaFilter || plantelFilter) && (
          <div className="col-12 col-sm-6 col-lg-2">
            <button
              className="btn btn-outline-secondary w-100 d-flex align-items-center justify-content-center gap-1"
              style={{ height: "44px" }}
              onClick={() => {
                dispatch(setEscuelaFilter(null));
              }}
            >
              <Icon icon="mdi:filter-remove-outline" width="18" />
              <span className="text-sm">Limpiar</span>
            </button>
          </div>
        )}
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        title="Crear nuevo usuario"
        size="lg"
      >
        <UserFormWizard onSuccess={handleClose} />
      </Modal>
    </div>
  );
};

export default UsersHeader;
